import { render } from "./BusinessUnitSwitcher.vue?vue&type=template&id=75dc2d2d&scoped=true&ts=true"
import script from "./BusinessUnitSwitcher.vue?vue&type=script&lang=ts"
export * from "./BusinessUnitSwitcher.vue?vue&type=script&lang=ts"

import "./BusinessUnitSwitcher.vue?vue&type=style&index=0&id=75dc2d2d&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dc2d2d"]])

export default __exports__